var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"register-dialog",attrs:{"max-width":_vm.$store.getters['View/isMobile'] ? '90vw' : '60vw',"value":_vm.getRegisterShow,"persistent":""}},[_c('v-card',{staticClass:"elevation-12"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }